import React from "react";
//import FullWidthCenteredLayout from "../../components/FullWidthCenteredLayout/FullWidthCenteredLayout";
import AuthPageLayout from "./AuthPageLayout";
import Auth2fa from "./components/Auth2fa";
import AuthAnonymous from "./components/AuthAnonymous";
import AuthPii from "./components/AuthPii";
import AuthB2C from "./components/AuthB2C";
import ErrorPage from "../ErrorPage/ErrorPage";
const AuthPageRoutes = {
  path: "auth",
  element: <AuthPageLayout />,
  children: [
    { path: "", element: <AuthB2C />, errorElement: <ErrorPage /> },
    { path: "2fa", element: <Auth2fa />, errorElement: <ErrorPage /> },
    { path: "pii", element: <AuthPii />, errorElement: <ErrorPage /> },
    { path: "Anonymous", element: <AuthAnonymous />, errorElement: <ErrorPage /> },
    { path: "b2c", element: <AuthB2C />, errorElement: <ErrorPage /> },
  ],
};

export default AuthPageRoutes;
